export class Option {
  value!: Number;
  name!: String;
}
